import { useNavigate } from '@tanstack/react-router'
import { ArrowLeftIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { API_ERROR_CODES_MAP } from './constants'
import { ErrorGraphics } from './error-graphics'

export interface ErrorGuideProps {
  code?: string
  description?: string
}

export const ErrorGuide = ({ code, description }: ErrorGuideProps) => {
  const navigate = useNavigate()

  const handleClickBackButton = () => {
    void navigate({ to: '/upload-document' })
  }

  return (
    <div>
      <div
        className={cn(
          'flex flex-col items-center',
          'w-fit',
          'px-[15%] py-[30px]',
          'mx-auto',
          'rounded-[10px] border border-slate-300',
          'bg-white'
        )}
      >
        <ErrorGraphics />
        {code && description ? (
          <div>
            <p className={cn('mt-[30px]', 'text-center text-lg font-semibold text-red-700')}>
              {API_ERROR_CODES_MAP[Number(code)].title}
            </p>
            <p className={cn('mt-1', 'text-center text-lg font-semibold text-red-700')}>
              {API_ERROR_CODES_MAP[Number(code)].description}
            </p>
          </div>
        ) : (
          <div>
            <p className={cn('mt-[30px]', 'text-center text-lg font-semibold text-red-700')}>General System Error</p>
            <p className={cn('mt-1', 'text-center text-lg font-semibold text-red-700')}>
              We failed to upload your documents. Please try again.
            </p>
          </div>
        )}
      </div>

      <div className={cn('flex items-center justify-center', 'mt-4')}>
        <Button
          type="button"
          variant="outline"
          className={cn('flex items-center gap-x-2', 'w-[180px]', 'text-slate-900', 'border-slate-300 bg-slate-200')}
          onClick={handleClickBackButton}
        >
          <ArrowLeftIcon size={16} />
          <span>Back</span>
        </Button>
      </div>
    </div>
  )
}
